import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Service, HttpMethod} from '../../../domain/model/common/service.class';
import {DocumentsModel, DownloadableFiles} from './documents.model';

const CURRENT_USER_PATH = 'currentUser';

@Injectable()
export class DocumentsService extends Service {
    constructor(
        svcm: Service.InjectedMembers) {
        super(svcm, 'document');
    }

    getDocuments(): Observable<DocumentsModel | undefined> {
        return this.get(DocumentsModel, CURRENT_USER_PATH);
    }

    requestDownload(payload: Array<Object>): Observable<any> {
        return this.call(CURRENT_USER_PATH, undefined, payload, HttpMethod.POST, true);
    }

    getDownloadableFiles(): Observable<DownloadableFiles> {
        return this.get(DownloadableFiles, `zip/${CURRENT_USER_PATH}?projection=files`);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/documents/model/documents-service.ts